import { render } from "./index.vue?vue&type=template&id=2b501a10"
const script = {}

import exportComponent from "D:\\project\\official-website-manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__